
import { useEffect, useCallback, useReducer } from "react";
import { Model } from "../models/model";

const getEmptyForm = () => ({
    id: null,
    tipo: null,
    origen: null,
    id_origen: null,
    nombre: null,
    created: false,
    fecha_inicio: null,
    fecha_fin: null,
    date_change_option: 'esta_tarea',
    labels: []
});

const getInitialState = ({ id_ppto = null } = {}) => ({
    hitos: [],
    tasks: [],
    form: getEmptyForm(),
    filters: {
        id_ppto: id_ppto,
        view: 'list',
        id_responsable: 0,
        estado: ''
    },
    optionView: 'list',
    openDialog: false,
    loading: false,
    error: null
});

function reducerActions(state, action) {
    switch (action.type) {
        case "LOAD_HITOS":
            return {
                ...state,
                hitos: action.payload,
            };

        case "LOAD_TASKS":
            return {
                ...state,
                tasks: action.payload,
            };

        case "SET_FORM":
            return {
                ...state,
                form: {
                    ...state.form,
                    ...action.payload,
                },
            };

        case "RESET_FORM":
            return {
                ...state,
                form: getEmptyForm(),
            };

        case "OPEN_EDIT":
            return {
                ...state,

                form: {
                    ...action.payload
                },

                openDialog: true
            };

        case "OPEN_CREATE":
            return {
                ...state,
                form: getEmptyForm(),
                openDialog: true
            };

        case "SET_FILTER":
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.payload.name]: action.payload.value
                },
            };

        case "SET_OPEN_DIALOG":
            return {
                ...state,
                openDialog: action.payload
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: action.payload
            };

        case "SET_OPTION_VIEW":
            return {
                ...state,
                optionView: action.payload,
            };

        default:
            return state;
    }
}

export function useTask({ id_ppto }) {

    const [state, dispatch] = useReducer(reducerActions, getInitialState({ id_ppto }))
    const { hitos, tasks, form, filters, openDialog, loading, optionView } = state

    const getHitos = useCallback(async () => {
        try {

            const results = await Model.getAll({
                url: `tasks/hitos/byppto/${filters.id_ppto}`,
            });

            dispatch({
                type: "LOAD_HITOS",
                payload: results,
            });

        } catch (error) {

            dispatch({
                type: "SET_ERROR",
                payload: error.message,
            });

        }
    }, [filters]);

    const getTasks = useCallback(async () => {
        try {

            const params = new URLSearchParams(filters).toString();
            const results = await Model.getAll({
                url: `tasks/?${params}`,
            });

            dispatch({
                type: "LOAD_TASKS",
                payload: results,
            });

        } catch (error) {

            dispatch({
                type: "SET_ERROR",
                payload: error.message,
            });

        }
    }, [filters]);

    const setOpenDialog = (open) => {
        dispatch({
            type: "SET_OPEN_DIALOG",
            payload: open
        });
    };

    const setOptionView = (view) => {
        dispatch({
            type: "SET_OPTION_VIEW",
            payload: view,
        });
    };

    const openEdit = (task) => {
        dispatch({
            type: "OPEN_EDIT",
            payload: task,
        });
    };

    const openCreate = () => {
        dispatch({
            type: "OPEN_CREATE",
        });
    };

    const updateForm = (payload) => {
        dispatch({
            type: "SET_FORM",
            payload,
        });
    };

    const handleFilters = ({ target }) => {
        dispatch({
            type: "SET_FILTER",
            payload: {
                name: target.name,
                value: target.value,
            },
        });
    };

    const saveTask = async (task = state.form) => {
        try {

            dispatch({
                type: "SET_LOADING",
                payload: true
            });

            if (task.id) {

                await Model.update({
                    url: `tasks/${task.id}`,
                    dataForm: task,
                    resultData: true,
                });

            } else {

                await Model.save({
                    url: "tasks",
                    dataForm: task,
                    resultData: true,
                });

                dispatch({
                    type: "RESET_FORM",
                });

            }

            dispatch({
                type: "SET_LOADING",
                payload: false
            });


            await getTasks();

        } catch (error) {
            console.error(error);
        }
    };

    /*  useEffect(() => {
         getTasks();
     }, [filters, getTasks]); */

    useEffect(() => {
        getHitos();
    }, [filters, getHitos]);

    return {
        hitos,
        tasks,

        setOptionView,
        optionView,

        loading,
        openDialog,
        setOpenDialog,

        handleFilters,
        filters,

        form,
        openCreate,
        openEdit,

        updateForm,
        saveTask
    };
}